import {useMemo} from 'react';
import {t} from '../../../../common/getTranslations';
import {useDialog} from '../../../../dialog/useDialog.hook';
import {Bm, Maybe} from '../../../../graphql/generated/types';

export function useContentHomeWaitFreeDialog({
  isMobile,
  periodText,
  bm,
  waitfreeBlockCount,
}: {
  isMobile: boolean;
  periodText: string;
  bm: Maybe<Bm>;
  waitfreeBlockCount?: Maybe<number>;
}) {
  const {DialogWrapper, Dialog, showDialog, hideDialog} = useDialog({
    isMobile,
  });
  const dialogElem = useMemo(() => {
    return (
      <DialogWrapper>
        <Dialog.Dimmed />
        <Dialog.Title className="mb-6pxr">
          {t('contenthome_ep_tab_wuf_info_popup_title', {
            values: {value: periodText},
          })}
        </Dialog.Title>
        <Dialog.List className="space-y-0">
          <Dialog.Caption>
            {t('contenthome_waitfree_guide_message_1', {
              values: {
                value: periodText,
              },
            })}
          </Dialog.Caption>
          <Dialog.Caption>
            {t('contenthome_waitfree_guide_message_2')}
          </Dialog.Caption>
          {bm &&
            //  복합BM 은 기다무가 `최신편` 이 아니기 때문에 아예 보여주지 않습니다(기획 결정)
            bm !== Bm.MixedWaitfree &&
            bm !== Bm.MixedPay &&
            !!waitfreeBlockCount &&
            waitfreeBlockCount > 0 && (
              <Dialog.Caption>
                {t('contenthome_waitfree_guide_message_3', {
                  values: {
                    value: waitfreeBlockCount,
                  },
                })}
              </Dialog.Caption>
            )}
        </Dialog.List>
        <Dialog.BottomCombination>
          <Dialog.Button onClick={hideDialog}>
            {t('common_confirm_button')}
          </Dialog.Button>
        </Dialog.BottomCombination>
      </DialogWrapper>
    );
  }, [Dialog, DialogWrapper, bm, hideDialog, periodText, waitfreeBlockCount]);

  return {
    showDialog,
    hideDialog,
    waitFreeDialog: dialogElem,
  };
}
